module.exports = __webpack_public_path__ + "img/arrow.6c07fcb8.svg";